/// <amd-module name="Test/TestPlansHubRefresh/TestCaseWorkItemControls/AssociatedAutomation/Component/AssociatedAutomationControlConstants" />
export const AutomatedTestNameFieldName = "Microsoft.VSTS.TCM.AutomatedTestName";
export const AutomatedTestStorageFieldName = "Microsoft.VSTS.TCM.AutomatedTestStorage";
export const AutomatedTestTypeFieldName = "Microsoft.VSTS.TCM.AutomatedTestType";
export const AutomatedTestIdFieldName = "Microsoft.VSTS.TCM.AutomatedTestId";
export const AutomatedTestAutomationStatusFieldName = "Microsoft.VSTS.TCM.AutomationStatus";
    
